import { Outlet } from 'react-router-dom';
import { AuthExpirationListener } from '@/modules/auth/presentation/components/AuthExpirationListener';

export function RootLayout() {
  return (
    <>
      <AuthExpirationListener />
      <Outlet />
    </>
  );
}
